import client, { PRIVATE_CLIENT } from '../../services/client';
export const getWidgetConfig = async () => {
    const response = await client.get('third-party/sdk/live-widget/setting/', PRIVATE_CLIENT);
    return response;
};
export const getBusinessWidgetConfig = async (business_id) => {
    const response = await client.get(`business/${business_id}/addons/live-widget/setting/`, PRIVATE_CLIENT);
    return response;
};
export const getLiveReceiver = async (public_key) => {
    return await client.post('third-party/sdk/live-widget/support/receiver-line/', PRIVATE_CLIENT, {
        public_key
    });
};
export const getReceivingLines = async (public_key, receiver) => {
    return await client.post('telephony/crm/receiver-line/', PRIVATE_CLIENT, {
        public_key,
        receiver,
    });
};
